var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultadoCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.25 88.125L82.875 59.5L78 54.625L54.25 78.375L41.375 65.5L36.5 70.375L54.25 88.125ZM27.5 110C25.5 110 23.75 109.25 22.25 107.75C20.75 106.25 20 104.5 20 102.5V17.5C20 15.5 20.75 13.75 22.25 12.25C23.75 10.75 25.5 10 27.5 10H72.625L100 37.375V102.5C100 104.5 99.25 106.25 97.75 107.75C96.25 109.25 94.5 110 92.5 110H27.5ZM68.875 40.75V17.5H27.5V102.5H92.5V40.75H68.875Z",
    fill: "url(#paint0_linear_6_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_3",
    x1: 60,
    y1: 10,
    x2: 60,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D81C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2594BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultadoCard);
export default __webpack_public_path__ + "static/media/resultadoCard.e75a6a9ef9070d2984df3caa65142b44.svg";
export { ForwardRef as ReactComponent };